import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupPage } from "@/features/all-study-groups/components/StudyGroupPage";
import { isSafeInternalPath } from "@/lib/navigation/userProfileNavigation";

type StudyGroupDetailSearch = {
  action?: "join" | "apply";
  from?: string;
};

export const Route = createFileRoute("/all-study-groups/$study-group-id")({
  component: StudyGroupPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): StudyGroupDetailSearch => ({
    action:
      search.action === "join" || search.action === "apply"
        ? search.action
        : undefined,
    from: isSafeInternalPath(search.from) ? search.from : undefined,
  }),
});
